<!-- Main container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="create()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
        <ng-template elderToolbarContent="center">
          <elder-search-box
            class="flex-60 pt-xs"
            dense
            queryKey="query"
            [autoPanel]="false"
            [elderSearchContext]="data.filter"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let vendor">
          <mat-icon>person</mat-icon>
        </td>
      </ng-container>

      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.id' | translate }}
        </th>
        <td mat-cell *matCellDef="let vendor">{{ vendor?.id }}</td>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let vendor">{{ vendor?.name }}</td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
